import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

/**
 * Pages de retour après le tunnel de paiement Stripe.
 * `success` : le paiement a abouti (la confirmation réelle passe par le webhook
 * côté serveur ; cette page remercie et vide le panier). `success=false` :
 * paiement annulé, le panier est conservé pour réessayer.
 */
const OrderResultPage = ({ success }: { success: boolean }) => {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const orderNumber = params.get('order');
  const manual = params.get('manuel') === '1';

  // Le panier est vidé une fois la commande passée (succès ou paiement manuel).
  useEffect(() => {
    if (success) clear();
  }, [success, clear]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center p-8 border border-gray-800 rounded-2xl bg-gray-900/30">
        {success ? (
          <>
            <CheckCircle className="w-16 h-16 mx-auto text-green-500 mb-4" />
            <h1 className="text-2xl font-bold mb-2">Merci pour votre commande !</h1>
            {orderNumber && <p className="text-gray-400 mb-2">Commande <span className="font-mono text-white">{orderNumber}</span></p>}
            <p className="text-gray-400 mb-6">
              {manual
                ? 'Votre commande est enregistrée. Nous vous recontactons pour le règlement.'
                : 'Votre paiement a été reçu. Un email de confirmation vous sera envoyé.'}
            </p>
          </>
        ) : (
          <>
            <XCircle className="w-16 h-16 mx-auto text-red-500 mb-4" />
            <h1 className="text-2xl font-bold mb-2">Paiement annulé</h1>
            <p className="text-gray-400 mb-6">
              Votre commande n'a pas été validée. Votre panier a été conservé, vous pouvez réessayer.
            </p>
          </>
        )}
        <div className="flex gap-3 justify-center">
          <Link to="/boutique" className="px-6 py-3 rounded-full bg-red-600 hover:bg-red-700 text-white font-medium">
            Retour à la boutique
          </Link>
          {!success && (
            <Link to="/panier" className="px-6 py-3 rounded-full border border-gray-700 hover:bg-gray-800 text-white font-medium">
              Voir le panier
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderResultPage;
